<script setup lang="ts">
import type { Component } from 'vue'
import type { UiTone } from '~/utils/ui'
withDefaults(
  defineProps<{
    as?: string | Component
    padding?: 'none' | 'sm' | 'md' | 'lg'
    radius?: 'sm' | 'md' | 'lg'
    clip?: boolean
    border?: boolean
    shadow?: 'none' | 'sm' | 'md'
    tone?: UiTone
    interactive?: boolean
    selected?: boolean
    disabled?: boolean
  }>(),
  {
    interactive: undefined,
    selected: undefined,
    disabled: undefined,
    as: 'div',
    clip: false,
    padding: 'md',
    radius: 'md',
    border: true,
    shadow: 'none',
    tone: 'neutral',
  },
)
</script>
<template>
  <component
    :is="as"
    class="ui-surface"
    :class="[
      `ui-tone--${tone}`,
      `ui-padding--${padding}`,
      `ui-radius--${radius}`,
      `ui-shadow--${shadow}`,
      {
        'ui-surface--clip': clip,
        'ui-surface--border': border,
        'ui-surface--interactive': interactive,
        'ui-surface--selected': selected,
        'ui-disabled': disabled,
      },
    ]"
    :aria-disabled="disabled || undefined"
    ><slot name="header" /><slot /><slot name="footer"
  /></component>
</template>
